/* eslint-disable no-console */
export default function validateUDSConfig(config = {}) {
    const requiredConfigKeys = ['listingPrice', 'selectedCriteria', 'listing'];

    const configKeys = Object.keys(config);

    if (configKeys.length > 0) {
        requiredConfigKeys.forEach((key) => {
            if (!configKeys.includes(key)) {
                console.warn('Missing required UDS config: ', key);
            }
        });
    } else {
        console.error('UDS is initialized with a missing config');
    }
}
